import React, { FC, ReactNode } from "react";
import { Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  header: {
    fontWeight: 500,
  },
}));

interface ColumnHeaderProps {
  title: string;
  handleSort: (column: string) => void;
  icon?: ReactNode;
}

const ColumnHeader: FC<ColumnHeaderProps> = ({ title, handleSort, icon }) => {
  const classes = useStyles();

  return (
    <div className={classes.container} onClick={() => handleSort(title)}>
      <Typography variant="body2" className={classes.header}>
        {title}
      </Typography>
      {icon ? icon : null}
    </div>
  );
};

export default ColumnHeader;
